const OrderQtyAutofillType = {
    useForecastedQty: 'useForecastedQty',
    useRecommendedQty: 'useRecommendedQty',
    useReForecastQtyByCasePackQty: 'useReForecastQtyByCasePackQty',
    useReSupplierQtyByCasePackQty: 'useReSupplierQtyByCasePackQty',
    useReWarehouseQtyByCasePackQty: 'useReWarehouseQtyByCasePackQty'
};

module.exports = Object.freeze(OrderQtyAutofillType);